import FormValidations from 'data/FormValidations';
import {
  emptyValidation,
  minLengthValidation,
  noMatchValidation,
} from './constants';

export const hasErrors = (form, translations) => {
  const errors = {};
  Object.assign(
    errors,
    new FormValidations(form.oldpassword, 'oldpassword')
      .validateMinLongitude(1, emptyValidation(translations))
      .getErrors(),
  );

  Object.assign(
    errors,
    new FormValidations(form.newpassword, 'newpassword')
      .validateMinLongitude(6, minLengthValidation(translations))
      .getErrors(),
  );

  Object.assign(
    errors,
    new FormValidations(form.controlpassword, 'controlpassword')
      .validateMinLongitude(6, minLengthValidation(translations))
      .getErrors(),
  );

  Object.assign(
    errors,
    new FormValidations(form.newpassword, 'newpassword')
      .isEqual(form.controlpassword, noMatchValidation(translations))
      .getErrors(),
  );

  Object.assign(
    errors,
    new FormValidations(form.controlpassword, 'controlpassword')
      .isEqual(form.newpassword, noMatchValidation(translations))
      .getErrors(),
  );

  if (Object.keys(errors).length !== 0) {
    return errors;
  }

  return false;
};
